export const RESIDENCY_REJECTION_HEADING =
  'Trini Rewards is currently available to Trinidad residents only';

export const RESIDENCY_REJECTION_BODY =
  'Trini Rewards is currently open to people living in Trinidad and Tobago. We may expand to other regions in the future. Thanks for your interest in being part of it.';

export function ResidencyRejectionScreen({ className = '' }: { className?: string }) {
  return (
    <section
      aria-labelledby="residency-rejection-title"
      className={className}
      data-testid="residency-rejection"
    >
      <p className="design-eyebrow text-[var(--coral)]">Eligibility</p>
      <h2
        className="mt-2 text-[28px] font-black leading-tight tracking-normal text-[var(--ink)] sm:text-[36px]"
        id="residency-rejection-title"
      >
        {RESIDENCY_REJECTION_HEADING}
      </h2>
      <p className="mt-4 max-w-xl text-lg leading-normal text-[#1f2a37]">
        {RESIDENCY_REJECTION_BODY}
      </p>
    </section>
  );
}
